import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AccessGate({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  useEffect(() => {
    if (user?.role === 'cliente') axios.get(`${API}/api/me/access-status`).then(r => setStatus(r.data)).catch(() => {});
  }, [user]);
  if (!status?.access_ended) return children;
  return (
    <div className="max-w-md mx-auto text-center py-16 px-6" data-testid="access-ended-screen">
      <h2 className="font-heading text-2xl text-brand-text mb-3">O teu acompanhamento terminou</h2>
      <p className="text-sm text-brand-muted mb-6">O acesso aos teus planos e materiais terminou a {status.access_end_date.split('-').reverse().join('/')}. Os teus dados continuam guardados em segurança. Se quiseres voltar, marca uma nova consulta.</p>
      <a href="https://app.nutrianapereira.pt/agendarconsulta" className="inline-block bg-brand-green text-white rounded-full px-6 py-3 text-sm font-medium" data-testid="access-ended-book-btn">Marcar nova consulta</a>
    </div>
  );
}
